import {
  Box,
  Flex,
  HStack,
  Text,
  Image,
  useBreakpointValue,
} from "@chakra-ui/react";
import React, { useState } from "react";
import Fade from "react-reveal/Fade";

const CreditServicing = () => {
  const isXLScreen = useBreakpointValue({ base: false, xl: true });
  const isSmallScreen = useBreakpointValue({ base: true, xl: false });
  const [selectedOption, setSelectedOption] = useState(
    "Streamlined Credit Servicing"
  );

  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  const getContainerStyles = (option) => ({
    borderRadius: "5px",
    background: selectedOption === option ? "#FFF" : "#FFF",
    boxShadow:
      selectedOption === option
        ? "0px 4px 10px 0px rgba(0, 0, 0, 0.10)"
        : "none",
    color: selectedOption === option ? "#FD8534" : "#999",
    fontWeight: selectedOption === option ? "600" : "500",
    transition: "all 0.3s ease-in-out",
  });

  const optionDescriptions = {
    "Streamlined Credit Servicing":
      "Effortlessly manage Asset-Backed and Mortgage-Backed Securities, simplifying complex transactions for optimal efficiency.",
    "Smart Contract Automation":
      "Smart contracts automate deal structuring, data matching, and statement calculations, reducing errors and enhancing transaction speed.",
    "Precision in Processing":
      " With smart contracts, we ensure fast, accurate credit servicing, streamlining the financial management cycle for effectiveness.",
  };

  const optionImages = {
    "Streamlined Credit Servicing": require("../../../../assets/images/akruServicing/Group.png"),
    "Smart Contract Automation": require("../../../../assets/images/akruServicing/1.png"),
    "Precision in Processing": require("../../../../assets/images/akruServicing/2.png"),
  };

  return (
    <Box backgroundColor="#F9F9F9">
      <Box
        paddingBottom={{ base: "30px", xl: "100px" }}
        className={isXLScreen ? "container" : "container-responsive"}
      >
        <Box>
          <Flex
            alignItems={{ base: "start", xl: "center" }}
            flexDirection="column"
            paddingTop="100px"
          >
            <HStack
              width="100%"
              spacing="0"
              flexDirection={{ base: "column", lg: "row" }}
            >
              {Object.keys(optionDescriptions).map((option) => (
                <Text
                  key={option}
                  width={{ base: "100%", lg: "390px" }}
                  borderRadius="5px"
                  cursor="pointer"
                  textAlign="center"
                  fontSize={{ base: "12px", xl: "16px" }}
                  lineHeight={{ base: "28px", xl: "34px" }}
                  paddingY={{ base: "15px", xl: "20px" }}
                  paddingX={{ base: "20px", xl: "35px" }}
                  marginBottom={!isXLScreen && !isSmallScreen && "10px"}
                  onClick={() => handleOptionClick(option)}
                  {...getContainerStyles(option)}
                >
                  {option}
                </Text>
              ))}
            </HStack>
            {selectedOption && (
              <Box
                paddingTop={{ base: "0px", xl: "30px" }}
                marginLeft={!isXLScreen && !isSmallScreen && "20px"}
              >
                <Flex
                  paddingY={{ base: "0px", md: "50px", xl: "0px" }}
                  alignItems={{ base: "center", md: "start" }}
                  justifyContent="space-between"
                  flexDirection={{ base: "column", lg: "row" }}
                  width="fit-content"
                >
                  <Box
                    width={{ base: "100%", lg: "50%", xl: "40%" }}
                    paddingTop={{ base: "30px", xl: "60px" }}
                  >
                    <Fade left>
                      <Text
                        cursor="pointer"
                        color="#000"
                        fontSize={{ base: "28px", xl: "36px" }}
                        fontWeight={{ base: "600", xl: "500" }}
                        lineHeight={{ base: "40px", xl: "50px" }}
                        textAlign="start"
                      >
                        {selectedOption}
                      </Text>

                      <Text
                        paddingTop={{ base: "20px", xl: "30px" }}
                        color="#666"
                        fontWeight="400"
                        fontSize={{ base: "18px", xl: "20px" }}
                        lineHeight={{ base: "30px", xl: "30px" }}
                        textAlign="start"
                      >
                        {optionDescriptions[selectedOption]}
                      </Text>
                    </Fade>
                  </Box>
                  <Flex
                    paddingY={{ base: "60px", xl: "0px" }}
                    w={{ base: "fill-available", xl: "50%" }}
                    justifyContent="center"
                  >
                    <Fade right>
                      <Image
                        h="150px"
                        src={optionImages[selectedOption]}
                        alt={`Image for ${selectedOption}`}
                        objectFit="cover"
                        borderRadius="5px"
                        marginTop={{ base: "10px", xl: "80px" }}
                      />
                    </Fade>
                  </Flex>
                </Flex>
              </Box>
            )}
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default CreditServicing;
